import { Injectable, Input, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { MetaDataCache } from '../Models/CommonModels';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest } from '../Models/RequestModels';
import { UIState, UserState, ModuleMultilingualLabels } from '../Models/UIModels';
import { AppSettings } from '../Library/AppSettings';
import { StaffBasicInfo } from '../Models/GlobalEntities';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { MasterDataService } from './MasterDataService';
import { PMSService } from './PMSService';


@Injectable({
    providedIn: 'root',
})
export class PMSSignalRService extends BaseService {
    private _hubConnection: HubConnection;
    connectionEstablished = new EventEmitter<Boolean>();

    public connectionIsEstablished = false;
    GuestLookupChanged = new EventEmitter();

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService, protected pmsService: PMSService) {
        super();

    }

    public Init(): void {
        this.BaseURL = AppSettings.URL_PMSService;

        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }

    private createConnection() {
        let objThis = this;
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(this.BaseURL + 'PMSHub?SessionId=' + objThis.masterService.apiService.getSessionCookie())
            .withAutomaticReconnect()
            .build();
    }

    private startConnection(): void {
        if (this._hubConnection == undefined || this._hubConnection == null) {
            this.createConnection();
        }

        this._hubConnection
            .start()
            .then(() => {
                this.connectionIsEstablished = true;
                //console.log('Hub connection started');
                this.connectionEstablished.emit(true);

            })
            .catch(err => {
                this.connectionIsEstablished = false;
                //console.log('Error while establishing connection, retrying...');
                if (!AppSettings.APP_DEBUG) {
                    window.setTimeout(() => { this.startConnection() }, 5000);
                }

            });
    }

    private registerOnServerEvents(): void {
        this._hubConnection.onclose(err => {
            this.connectionIsEstablished = false;
            this.connectionEstablished.emit(false);
            if (!AppSettings.APP_DEBUG) {
                window.setTimeout(() => { this.startConnection() }, 5000);
            }
        });

        this._hubConnection.on('GuestLookupUpdated', (data: any, PropertyId: number) => {
            //console.info(data);
            this.pmsService.AddToGuestLookupCache(PropertyId, data);
        });

        this._hubConnection.on('CurrentReservation_Deleted', (PropertyId: number, TritonReservationId: number) => {
            //console.info(data);
            this.pmsService.DeleteFromGuestLookupCache(PropertyId, TritonReservationId);
        });

        this._hubConnection.on('ReloadGuestLookup', (data: any) => {
            //console.info(data);
            this.pmsService.SetGuestLookupCache(data);
        });
        this._hubConnection.on('pmsinterfacestatus', (data: any) => {
            console.log('pmsinterfacestatus', data);
        });

        this.connectionEstablished.subscribe(data => {
            //console.info("C = " + data);
            if (data == true)
                this.RegisterForProperties();
        });
    }

    private RegisterForProperties(): void {
        //console.info(this.masterService.GetPropertyIDs());

        this._hubConnection.invoke("RegisterForProperties", this.masterService.GetPropertyIDs()).then(data => {
            //console.info(data);
        });
    }
}
